<template>
  <Form
    url="/renovacoes/config/pagamento/update"
    v-if="!loader"
    :valor="valor"
  />
</template>

<script>
import Form from "./Form.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "app-config-renovacoes-pagamento-update",
  data() {
    return {
      valor: {},
      loader: true
    };
  },
  components: {
    Form
  },
  methods: {
    async getValor(id) {
      try {
        const { data } = await this.$http.post(
          "/renovacoes/config/pagamento/find",
          {
            id: id
          }
        );
        return data;
      } catch (error) {
        return null;
      }
    },
    async getInit() {
      try {
        const id = this.$route.params.id;

        const valor = await this.getValor(id);

        if (!valor.id || valor == null) {
          return this.$toast.error("Registro não encontrado!");
        }

        this.valor = await valor;
        this.loader = false;
      } catch (error) {
        console.log(error);
      }
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Configurações de Renovação"
      }
    ]);
    this.getInit();
  }
};
</script>
